document.addEventListener('alpine:init', () => {
  Alpine.data('audioToggle', (audioId) => {
    const notification = document.querySelector(`#${audioId}`);
    const audioPlayer = notification?.querySelector('[data-js-audio-player]');
    const openEvent = new CustomEvent('open-notification');
    const closeEvent = new CustomEvent('close-notification');
    const pauseEvent = new CustomEvent('pause-audio');
    const allAudio = document.querySelectorAll('[data-js-notification=audio]');

    return {
      isOpen: false,
      isPlaying: false,
      init() {
        notification?.addEventListener('is-closing', () =>
          this.handleNotificationClose(
            notification.contains(document.activeElement),
          ),
        );
      },
      open() {
        // Close any other open audio players
        allAudio.length && allAudio.forEach((el) => el.dispatchEvent(closeEvent));

        this.isOpen = true;

        document.emit;

        this.sendNotification(openEvent);
      },
      close() {
        this.isOpen = false;
        this.sendNotification(closeEvent);
      },
      handleClick() {
        this.isOpen ? this.close() : this.open();
      },
      handleNotificationClose(focus = false) {
        this.isOpen = false;
        audioPlayer?.dispatchEvent(pauseEvent);

        focus &&
          this.$refs.playButton.focus({
            preventScroll: true,
            focusVisible: true,
          });
      },
      sendNotification(event) {
        if (notification) {
          notification.dispatchEvent(event);
        } else {
          console.warn('Audo Player not connected');
        }
      }
    };
  });
});
